const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  OEMInfo: state => state.app.OEMInfo,
  menuSize: state => state.app.menuSize,
  defaultPercent: state => state.app.defaultPercent,
  theme: state => state.app.theme,
  customThemes: state => state.app.customThemes,
  themeName: state => state.app.themeName,
  device: state => state.app.device,
  disableTree: state => state.app.disableTree,
  backgroundColor: state => state.app.backgroundColor,
  textColor: state => state.app.textColor,
  activeTextColor: state => state.app.activeTextColor,
  logoBackgroundColor: state => state.app.logoBackgroundColor,
  workStationLogo: state => state.app.workStationLogo,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  needRefresh: state => state.tagsView.needRefresh,
  userId: state => state.user.userId,
  solutionId: state => state.user.solutionId,
  ak: state => state.user.ak,
  currentName: state => state.user.currentName,
  connectInfo: state => ({
    templateId: state.tagsView.lastTab.connectTemplateId,
    recordId: state.tagsView.lastTab.connectRecordId,
    connectId: state.tagsView.lastTab.connectId
  }),
  lastTab: state => state.tagsView.lastTab,
  lastActiveDecision: state => state.decision.lastActive,
  refreshing: state => state.decision.refreshing,
  showRefresh: state => state.app.showRefresh,
  formFilter: state => state.app.formFilter,
  storeTemporaryId: state => state.app.temporaryId,
  copyCreateRID: state => state.app.copyCreateRID,
  onlyOfficeSetting: state => state.app.onlyOfficeSetting,
  fontList: state => state.app.fontList,
  currentDecision: state => state.decision.currentObj,
  fillInfo: state => state.app.fillInfo
}
export default getters
